import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ErrorBoundary/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/containers/treasury/TreasuryLayout.tsx")